import { updateState, withDevtools, withFeatureFactory } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setPageNumber, setPageSize, withPagination, withPaginationMethods } from '@shared/state/pagination.feature';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { pipe, switchMap, tap } from 'rxjs';
import { FilterInviteRequest } from '../model/filter-invite-request.model';
import { Invite } from '../model/invite.model';
import { InviteService } from '../service/invite.service';

export const InviteStore = signalStore(
  withDevtools('invite'),
  withState({
    data: null as Invite[] | null,
  }),
  withRequestStatus(),
  withFeatureFactory((store) => withPagination<Invite>(store.data)),
  withComputed(({ data }) => ({
    invites: computed(() => data()),
  })),
  withMethods((store, inviteService = inject(InviteService)) => ({
    load: rxMethod<FilterInviteRequest>(
      pipe(
        tap(({ pageNumber, pageSize, enableGlobalLoader }) => {
          if (!enableGlobalLoader) {
            updateState(store, '[InviteStore] Set pending', setPending());
          }
          updateState(store, '[InviteStore] Set page number', setPageNumber(pageNumber));
          updateState(store, '[InviteStore] Set page size', setPageSize(pageSize));
        }),
        switchMap(({ organizationId, search, enableGlobalLoader }) =>
          inviteService
            .getInvites({
              organizationId,
              search,
              pageSize: store.pageSize(),
              pageNumber: store.pageNumber(),
              enableGlobalLoader,
            })
            .pipe(
              tapResponse({
                next: (data) => {
                  updateState(store, '[InviteStore] Set fulfilled', setFulfilled());
                  updateState(store, '[InviteStore] Set data', { data });
                },
                error: () => {
                  updateState(store, '[InviteStore] Set error', setError());
                  updateState(store, '[InviteStore] Set data', { data: null });
                },
              }),
            ),
        ),
      ),
    ),
  })),
  withFeatureFactory((store) => withPaginationMethods(store)),
);
